import { useInjection } from "inversify-react";
import { useCallback, useEffect, useState } from "react";
import ApiService from "../../../services/apiService";
import { ProductStatisticsApi, ProductStatisticsCreateDto, ProductStatisticsUpdateDto } from "../../../api";
import ProductStatisticsModalForm from "./productStatisticsModalForm";
import {useParams} from "react-router-dom";

export default function ProductStatisticsModalFormAddContainer(props: ProductStatisticsModalFormAddContainerProps) {
    const apiService = useInjection(ApiService);
    const [productStatisticsToEdit, setProductStatisticsToEdit] = useState<ProductStatisticsUpdateDto | null>(null);
    let {productId} = useParams();

    const onSubmit = useCallback(async (values: ProductStatisticsCreateDto | ProductStatisticsUpdateDto) => {
            values.productId = +productId!;
            try {
                if (!props.id) {
                    await apiService.getApi(ProductStatisticsApi).apiProductStatisticsPost(values);
                } else {
                    await apiService.getApi(ProductStatisticsApi).apiProductStatisticsIdPut(props.id, values)
                }
    
                await props.onFinish(true);            
            } catch (e: any) {
                return e.response.data;
            }
        }, [apiService, props.id]);
    
    const getProductStatisticsToEdit = useCallback(async () => {
    
        if (!props.id) {
            return;
        }
    
        const response = await apiService.getApi(ProductStatisticsApi).apiProductStatisticsIdGet(props.id);

        setProductStatisticsToEdit(response.data);
    
    }, [apiService, props.id]);

    useEffect(() => {
        getProductStatisticsToEdit();

        return () => setProductStatisticsToEdit(null);
    }, [getProductStatisticsToEdit]);

    if (props.id && !productStatisticsToEdit) {
        return null;
    }

    if (props.id === null && productStatisticsToEdit) {
        return null;
    }

    return <>
        <ProductStatisticsModalForm
            isModalVisible={props.addFormVisibility}
            setModalVisibility={props.onFinish}
            onSubmit={onSubmit}
            modalTitle={props.title}
            saveButtonTitle={"Zapisz"}
            cancelButtonTitle={"Anuluj"}
            initialValues={productStatisticsToEdit!}
        />
    </>
}

interface ProductStatisticsModalFormAddContainerProps {
    onFinish: (refreshList: boolean) => void,
    addFormVisibility: boolean,
    title: string,
    id?: number | null
}
